export default __webpack_public_path__ + "static/petha-b8b83b4f5d10291bbf00dbabf8b903ba.png";